export const SHAKE_FLAVORS = [
  'Vanilla',
  'Strawberry',
  'Raspberry',
  'Coconut',
  'Mocha',
  'Caramel',
  'Cinnamon',
  'Chocolate',
  'Banana',
  'Hazelnut',
  'Cherry',
  'Mango',
  'Pineapple',
];

export const PIZZA_TOPPINGS = [
  'Pepperoni',
  'Ham & pineapple',
  'Meat lover',
  'Cheese',
  'Butter chicken',
  'Buffalo chicken',
  'Pulled pork',
  'Veggie paneer',
  'BLT',
  'Bacon & egg',
  'Chicken tikka',
  'Chicken korma',
];

export const SPECIALTY_COFFEE_STYLES = [
  'German chocolate mocha',
  'Caramel macchiato',
  'Macchiato',
  'White chocolate mocha',
  'Mocha',
  'Latte',
  'Cappuccino',
  'Cariboo Classic',
  'Rick Classic',
  'Slammer',
  'Cinnamon Splash',
  'Misto',
  'Brutal',
  'London Fog',
];

export const NACHO_SALAD_ADDONS = [
  'No add-on',
  'Grilled chicken',
  'Crispy chicken',
  'Tandoori chicken',
  'Bacon',
  'Ham',
  'Roast beef',
  'Pulled pork',
];

// Parse "$5.72 / $7.62" or "+$2.86 / +$4.76" → [{label, price}]
export const parseSizes = (priceStr) => {
  if (!priceStr || !priceStr.includes('/')) return null;
  const parts = priceStr.split('/').map((p) => p.trim());
  if (parts.length !== 2) return null;
  return [
    { label: 'Small', price: parts[0] },
    { label: 'Large', price: parts[1] },
  ];
};

export const menuData = {
  breakfast: {
    title: 'Breakfast',
    image: 'https://images.unsplash.com/photo-1627308595181-555c07449ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxicmVha2Zhc3QlMjBiYWdlbHxlbnwwfHx8fDE3ODkwODIxNTF8MA&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Plain bagel', price: '$2.86' },
      { name: 'English breakfast muffin', price: '$5.72' },
      { name: 'Breakfast burrito', price: '$5.72' },
      { name: 'Breakfast bagel', price: '$11.43' },
      { name: 'Bliss hash & eggs', price: '$11.43' },
      { name: 'French toast', price: '$11.43' },
      { name: 'Hot skillet breakfast', price: '$14.29' },
      { name: 'Crispy coated fries', price: '$5.72 / $7.62' },
      { name: 'Homemade potato wedges', price: '$7.62 / $9.52' },
      { name: 'Onion rings', price: '$7.62 / $9.52' },
    ],
  },
  burgers: {
    title: 'Burgers, Sandwiches & Wraps',
    image: 'https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxidXJnZXIlMjBmcmllc3xlbnwwfHx8fDE3ODkwODIxNTF8MA&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Correlieu burger', price: '$10.48' },
      { name: 'Bliss burger', price: '$13.34' },
      { name: 'Bliss Prime burger', price: '$15.24' },
      { name: 'Breaded chicken burger', price: '$12.38' },
      { name: 'Flame-grilled chicken burger', price: '$12.38' },
      { name: 'Veggie burger', price: '$13.34' },
      { name: 'Homemade veggie burger', price: '$13.34' },
      { name: 'Mega sandwich', price: '$9.52 / $13.34' },
      { name: 'Mega wrap', price: '$9.52' },
      { name: 'Chicken strips & fries', price: '$13.32' },
      { name: "Kids' chicken nuggets, fries & dip", price: '$5.72' },
    ],
  },
  indian: {
    title: 'Indian Cuisines',
    image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjdXJyeXxlbnwwfHx8fDE3ODkwODIxNTd8MA&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Bliss ribs', price: '$14.29 / $23.81' },
      { name: 'Butter chicken', price: '$14.29 / $23.81' },
      { name: 'Curry chicken', price: '$14.29 / $23.81' },
      { name: 'Chicken, lamb or veggie korma', price: '$14.29 / $23.81' },
      { name: 'Chicken or veggie tikka', price: '$14.29 / $23.81' },
      { name: 'Hot skillet entrée', price: '$17.15' },
      { name: 'Chicken biryani', price: '$17.15' },
      { name: 'Veggie biryani', price: '$17.15' },
      { name: 'Tandoori chicken', price: '$17.15' },
      { name: 'Add naan or rice', price: '$2.86' },
    ],
  },
  pizza: {
    title: 'Poutine, Pizza & Bliss Bowls',
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMHNsaWNlfGVufDB8fHx8MTc4OTA4MjE1N3ww&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Bliss poutine', price: '$8.58 / $10.48' },
      { name: 'Extra cheese & gravy', price: '$1.90 / $2.38' },
      { name: 'Loaded poutine', price: '+$2.86 / +$4.76' },
      { name: 'Naan pizza', price: '$13.34', toppings: PIZZA_TOPPINGS },
      { name: 'Large thin-crust pizza', price: '$16.67', toppings: PIZZA_TOPPINGS },
      { name: 'Butter chicken Bliss Bowl', price: '$17.15' },
      { name: 'Butter chicken perogies', price: '$11.90' },
    ],
    footnote:
      'Pizza choices: pepperoni, ham & pineapple, meat lover, cheese, butter chicken, buffalo chicken, pulled pork, veggie paneer, BLT, bacon & egg, chicken tikka or chicken korma.',
  },
  appetizers: {
    title: 'Appetizers, Nachos & Salads',
    image: 'https://images.unsplash.com/photo-1570466199120-80bba1eabad7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxuYWNob3N8ZW58MHx8fHwxNzg5MDgyMTU3fDA&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Veggie samosa', price: '$1.38' },
      { name: 'Samosa by the dozen', price: '$25.00' },
      { name: 'Veggie pakoras', price: '$3.33' },
      { name: '3 pakoras & salad', price: '$6.67' },
      { name: 'Samosa, channa & naan', price: '$6.67' },
      { name: 'Chicken pakoras & salad', price: '$9.53' },
      { name: 'Bliss nachos', price: '$7.62', addons: NACHO_SALAD_ADDONS },
      { name: 'Tossed salad', price: '$3.80 / $7.62', addons: NACHO_SALAD_ADDONS },
      { name: 'Caesar salad', price: '$4.76 / $7.62', addons: NACHO_SALAD_ADDONS },
      { name: 'Curry chicken soup', price: '$7.14' },
      { name: 'Weekly special veggie soup', price: '$7.14' },
    ],
    footnote:
      'Nacho and salad add-ons include grilled or crispy chicken, tandoori chicken, bacon, ham, roast beef and pulled pork.',
  },
  coffee: {
    title: 'Specialty Coffees & Tea',
    image: 'https://images.pexels.com/photos/4913342/pexels-photo-4913342.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    items: [
      { name: 'Specialty coffee', price: '$3.80', styles: SPECIALTY_COFFEE_STYLES },
      { name: 'Hot chocolate', price: '$2.86' },
      { name: 'Americano', price: '$2.36' },
      { name: 'Single espresso', price: '$1.43' },
      { name: 'Double espresso', price: '$2.36' },
      { name: '12 oz. stay cup coffee', price: '$0.95' },
      { name: '16 oz. go cup coffee', price: '$1.90' },
      { name: 'Tea', price: '$1.43 / $1.90' },
      { name: 'Steamed chai', price: '$3.33' },
      { name: 'Iced or authentic chai', price: '$3.80' },
      { name: 'Non-dairy milk', price: '+$0.95' },
    ],
    footnote:
      'Specialty coffees include German chocolate mocha, caramel macchiato, macchiato, white chocolate mocha, mocha, latte, cappuccino, Cariboo Classic, Rick Classic, Slammer, Cinnamon Splash, Misto, Brutal and London Fog.',
  },
  cold: {
    title: 'Cold Drinks',
    image: 'https://images.unsplash.com/photo-1570968915860-54d5c301fa9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxjaGFpJTIwbGF0dGV8ZW58MHx8fHwxNzg5MDgyMTU3fDA&ixlib=rb-4.1.0&q=85',
    items: [
      { name: 'Italian cream soda', price: '$3.80', flavors: SHAKE_FLAVORS },
      { name: 'Milkshake', price: '$3.80 / $4.76', flavors: SHAKE_FLAVORS },
      { name: 'Smoothie', price: '$4.76', flavors: SHAKE_FLAVORS },
      { name: 'Frappuccino', price: '$3.80', flavors: SHAKE_FLAVORS },
      { name: 'Bliss iced tea & lemonade', price: '$2.86' },
    ],
    footnote:
      'Cream soda, shake and smoothie flavours include vanilla, strawberry, raspberry, coconut, mocha, caramel, cinnamon, chocolate, banana, hazelnut, cherry, mango and pineapple.',
  },
};

export const reviews = [
  {
    name: 'Google reviewer',
    source: 'Google review',
    initial: 'M',
    text: 'Best coffee ever. Very good prices, excellent food & great service.',
  },
  {
    name: 'Google reviewer',
    source: 'Google review',
    initial: 'D',
    text: 'Very tasty vegan burger with homemade fries and a chai latte with almond milk.',
  },
  {
    name: 'Facebook reviewer',
    source: 'Facebook · 73 votes',
    initial: 'L',
    text: 'A proper slow-morning spot. Steady, warm, and never rushed you out of your seat.',
  },
];

export const heroImage =
  'https://images.unsplash.com/photo-1593443320739-77f74939d0da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxsYXR0ZSUyMGFydHxlbnwwfHx8fDE3ODkwODIxNTF8MA&ixlib=rb-4.1.0&q=85';

export const poutineImage =
  'https://images.unsplash.com/photo-1586805608485-add336722759?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwb3V0aW5lfGVufDB8fHx8MTc4OTA4MjY5NHww&ixlib=rb-4.1.0&q=85';

export const chaiImage =
  'https://images.unsplash.com/photo-1570968915860-54d5c301fa9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxjaGFpJTIwbGF0dGV8ZW58MHx8fHwxNzg5MDgyMTU3fDA&ixlib=rb-4.1.0&q=85';
